import { Link } from 'react-router-dom';

export default function ModulosPreviewSection() {
  const modulos = [
    'Identidade',
    'Autoliderança',
    'Propósito',
    'Mentalidade e Tempo',
    'Comunicação',
    'Posicionamento',
    'Networking',
    'Liderança de Times',
    'Ego e Maturidade',
    'Legado e Visão'
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-display text-5xl lg:text-6xl font-bold text-purple-900 mb-6">
            10 Módulos de Transformação
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Uma jornada completa de <strong>desenvolvimento em liderança feminina</strong>, 
            do autoconhecimento ao legado
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12">
          {modulos.map((modulo, index) => (
            <div
              key={index}
              className="bg-white border-2 border-purple-100 rounded-2xl p-6 flex items-center space-x-6 hover:border-purple-400 hover:shadow-lg transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center flex-shrink-0 bg-gold-500 rounded-full">
                <span className="text-white font-bold text-xl">{String(index + 1).padStart(2, '0')}</span>
              </div>
              <h3 className="text-2xl font-bold text-purple-900">{modulo}</h3>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/modulos"
            className="inline-block bg-purple-600 text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-purple-700 transition-all hover:scale-105 shadow-lg whitespace-nowrap"
          >
            Ver detalhes dos módulos
          </Link>
        </div>
      </div>
    </section>
  );
}
